import {
  Component, EventEmitter, Input, OnInit,
  Output, SimpleChanges, ElementRef, QueryList, ViewChildren
} from '@angular/core';
import EndlessOfferTrackDTO from '../../dtos/EndlessOfferTrackDTO';
import DynamicFormFieldDTO from 'src/app/common/components/dynamic-form-v2/dtos/DynamicFormFieldDTO';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { EndlessOfferService } from 'src/app/common/services/endless-offer.service';
import { OptionsParams, UtilitiesService } from 'src/app/common/services/utilities.service';
import { ChangeDetectorRef } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
import { LoggerService } from 'src/app/common/services/logger.service';


@Component({
  selector: 'eo-rewards-track-dynamic-field',
  templateUrl: './eo-rewards-track-dynamic-field.component.html',
  styleUrls: ['./eo-rewards-track-dynamic-field.component.css']
})
export class EORewardsTrackDynamicFieldComponent implements OnInit {
  @ViewChildren('bundleItem') bundleItems: QueryList<ElementRef>;


  @Input() endlessOfferTrackRecord: EndlessOfferTrackDTO = new EndlessOfferTrackDTO();
  @Input() field: DynamicFormFieldDTO = new DynamicFormFieldDTO();
  @Input() options: any[] = [];
  @Input() columnCount: number = 2;
  @Input() dropdownOptions: any = {};
  @Input() parentFieldData: any;
  @Input() isTemplate: boolean = false; // Flag to indicate if this is a reward track template
  @Output() onRecordChange = new EventEmitter<any>();
  @Output() onTrackChange = new EventEmitter<any>();

  public isLoading: boolean = true;
  public types: any[] = [
    { label: 'Rewards', value: 'free' },
    { label: 'Store Listings', value: 'paid' },
  ];
  public rewards_credits: any[] = [];

  filteredPaidOptions: any[];

  constructor(
    private http: HttpClient,
    private endlessOfferService: EndlessOfferService,
    private utilitiesService: UtilitiesService,
    private messageService: MessageService,
    private logger: LoggerService,
  ) { }

  /**
   * Rewards Track Dynamic Field Component Initialization
   */
  async ngOnInit() {
    const getOptionsParams = new OptionsParams({
      entity: 'store-listings-v2',
      select: 'id name pricePoint_ref credits_ref'
    });
    await this.utilitiesService.getOptions(this.dropdownOptions, 'storeListing_ref', getOptionsParams);
    await this.initializeComponent();
    // await this.endlessOfferService.getRewardsData(
    //   this.endlessOfferTrackRecord,
    //   this.setLoadingState.bind(this)
    // );
    await this.endlessOfferService.buildDisplayData(this.endlessOfferTrackRecord);

    this.extractRewardsCreditsQA();

    this.isLoading = false;

  }

  private async initializeComponent() {
    if (this.field.options && this.field.options.createOrSelect && this.field.options.createOrSelect.child) {
      // Get the parent key (e.g., 'track_v2_ref')
      const parentKey = this.field.options.createOrSelect.parentKey;

      // Check if track_v2_ref is already populated with the full track data (including EOrewards or EObundles)
      const populatedTrack = this.endlessOfferTrackRecord[parentKey];
      const hasPopulatedData = populatedTrack && typeof populatedTrack === 'object' && (
        (Array.isArray(populatedTrack.EOrewards) && populatedTrack.EOrewards.length > 0) ||
        (Array.isArray(populatedTrack.EObundles) && populatedTrack.EObundles.length > 0)
      );
      if (hasPopulatedData) {
        // Use the already populated track data
        this.endlessOfferTrackRecord['_id'] = populatedTrack._id;
        this.endlessOfferTrackRecord['EOrewards'] = populatedTrack.EOrewards;
        this.endlessOfferTrackRecord['EObundles'] = populatedTrack.EObundles || [];
        this.endlessOfferTrackRecord['isLoop'] = populatedTrack.isLoop;
        // Check if the populated track is a template
        if (this.isTemplate === false && populatedTrack.isTemplate === true) {
          this.isTemplate = true;
        }
      } else if (this.parentFieldData === "createNew") {
        // User selected "Create new" - set _id to signal new track creation
        this.endlessOfferTrackRecord['_id'] = "createNew";
        this.endlessOfferTrackRecord['EOrewards'] = [];
        this.endlessOfferTrackRecord['EObundles'] = [];
        this.endlessOfferTrackRecord['isLoop'] = false;
      } else if (this.parentFieldData) {
        await this.endlessOfferService.initializeTrackFromParentData(
          this.parentFieldData,
          this.options,
          this.endlessOfferTrackRecord
        );
        // Check if the initialized track is a template
        if (this.isTemplate === false && (this.endlessOfferTrackRecord as any).isTemplate === true) {
          this.isTemplate = true;
        }
      }
    }

    // If isTemplate is not set but the record has it, use the record's value
    if (this.isTemplate === false && this.endlessOfferTrackRecord && (this.endlessOfferTrackRecord as any).isTemplate === true) {
      this.isTemplate = true;
    }

    if (!this.endlessOfferTrackRecord['EObundles']) {
      this.endlessOfferTrackRecord['EObundles'] = [];
    }
    if (!this.endlessOfferTrackRecord['EOrewards']) {
      this.endlessOfferTrackRecord['EOrewards'] = [];
    }

    // Sync EObundles with EOrewards if they're out of sync
    // This handles cases where templates have EOrewards but missing EObundles
    this.syncBundlesWithRewards();

  }

  /**
   * Syncs EObundles with EOrewards to ensure they have matching lengths.
   * If EOrewards has items but EObundles is empty/shorter, generate EObundles entries.
   * This handles templates that were created with EOrewards but without corresponding EObundles.
   */
  private syncBundlesWithRewards(): void {
    const rewards = this.endlessOfferTrackRecord['EOrewards'] || [];
    const bundles = this.endlessOfferTrackRecord['EObundles'] || [];

    // If EOrewards has more items than EObundles, generate missing bundles
    if (rewards.length > bundles.length) {
      for (let i = bundles.length; i < rewards.length; i++) {
        // Determine bundle type based on reward data
        const reward = rewards[i];
        let bundleType = null;

        if (reward && Array.isArray(reward) && reward.length > 0) {
          // Check if it's a paid (StoreListingV2 or DynamicMysteryBox) or free reward
          const firstReward = reward[0];
          if (firstReward && (firstReward.lineItemType === 'StoreListingV2' || firstReward.lineItemType === 'DynamicMysteryBox')) {
            bundleType = 'paid';
          } else if (firstReward && (firstReward.t || firstReward.lineItemType)) {
            bundleType = 'free';
          }
        }

        if (!this.endlessOfferTrackRecord['EObundles']) {
          this.endlessOfferTrackRecord['EObundles'] = [];
        }
        this.endlessOfferTrackRecord['EObundles'].push({
          type: bundleType,
          index: i
        });
      }
    }
  }


  async ngOnChanges(changes: SimpleChanges) {
    // Re-initialize if parentFieldData changes (after first load)
    // OR if options are loaded/changed and we haven't loaded track data yet
    const hasNoTrackData = !this.endlessOfferTrackRecord['EOrewards']?.length &&
                           !this.endlessOfferTrackRecord['EObundles']?.length;
    const shouldReinitialize =
      (changes.parentFieldData && !changes.parentFieldData.firstChange) ||
      (changes.options && this.options?.length > 0 && hasNoTrackData);

    if (shouldReinitialize) {
      this.isLoading = true;
      await this.initializeComponent();
      await this.endlessOfferService.buildDisplayData(this.endlessOfferTrackRecord);
      this.extractRewardsCreditsQA();
      this.isLoading = false;
    }
  }

  /**
   * Handle Record Changes
   *
   * @param field Field that changed.y
   * @param event Value changed.
   */
  onChange(field: string, event: any) {
    this.logger.log('Record:', this.endlessOfferTrackRecord);
    this.onTrackChange.emit(this.endlessOfferTrackRecord);
    this.onRecordChange.emit({ field: field, record: this.endlessOfferTrackRecord, change: event });
  }


  addBundle(): void {
    const index = this.endlessOfferTrackRecord['EObundles']?.length || 0;
    this.endlessOfferTrackRecord['EObundles']?.push({ type: null, index: index });

    if (!this.endlessOfferTrackRecord.EOrewards) {
      this.endlessOfferTrackRecord.EOrewards = [];
    }

    if (this.endlessOfferTrackRecord.EOrewards) {
      this.endlessOfferTrackRecord.EOrewards = [...this.endlessOfferTrackRecord.EOrewards, [{ t: null, c: 5, id: null, lineItemType: null }]]
    }

    // Trigger the scroll to the new item
    this.scrollToNewItem();

  }

  onTypeChange(event: any, index: number): void {
    if (event.value === 'paid') {
      // Initialize EOrewards as an array if it does not exist yet
      if (!this.endlessOfferTrackRecord.EOrewards) {
        this.endlessOfferTrackRecord.EOrewards = [];
      }

      while (index >= this.endlessOfferTrackRecord.EOrewards.length) {
        this.endlessOfferTrackRecord.EOrewards.push(undefined);
      }

      // Now we can safely assign the new reward to the specific index
      // Allow empty id for templates (store listing can be empty)
      const newReward = {
        t: "654c04eb527d4031196b7561",
        id: this.isTemplate ? null : { _id: null }, // Allow null for templates, use object for non-templates
        c: 1,
        lineItemType: "StoreListingV2"
      };
      this.endlessOfferTrackRecord.EOrewards[index] = [newReward];
    }
  }


  async onSearchPaidOptions(event: any) {
    let query = event.query.toLowerCase();
    let result = await this.http.get<any>(`/api/endless-offer-track/store/listing?searchBy=${query}`).toPromise();
    this.filteredPaidOptions = result.storeListings;
  }

  async onSelectPaidOption(event: any, index: number) {
    // Handle both ngModelChange (event is value directly) and onChange (event.value)
    const selectedValue = event?.value !== undefined ? event.value : event;

    // Handle null/undefined value (when dropdown is cleared)
    // Only allow clearing for templates
    if (!selectedValue || selectedValue === null) {
      if (this.isTemplate) {
        // If store listing is cleared, set id to null (allows empty store listings in templates)
        if (this.endlessOfferTrackRecord && this.endlessOfferTrackRecord.EOrewards && this.endlessOfferTrackRecord.EOrewards[index]) {
          if (this.endlessOfferTrackRecord.EOrewards[index][0]) {
            this.endlessOfferTrackRecord.EOrewards[index][0].id = null;
            this.onChange('EOrewards', {});
          }
        }
      }
      // For non-templates, don't allow clearing - just return
      return;
    }

    // Check if storeListing_ref exists
    if (!this.dropdownOptions || !this.dropdownOptions.storeListing_ref) {
      this.logger.warn('storeListing_ref options not available');
      return;
    }

    const storeListingRefClone = cloneDeep(this.dropdownOptions.storeListing_ref);

    // Find the matching option where _id equals the selected value
    let matchingOption = storeListingRefClone.find((option: { _id: any; }) => option && option._id === selectedValue);

    // Ensure a matching option was found
    if (!matchingOption) {
      return; // Exit the function if no matching option is found
    }

    if (this.endlessOfferTrackRecord && this.endlessOfferTrackRecord.EOrewards && this.endlessOfferTrackRecord.EOrewards[index]) {

      if (!this.endlessOfferTrackRecord.EOrewards) {
        this.endlessOfferTrackRecord.EOrewards = [];
      }

      // Create the new reward object using the _id of the matching option
      const newReward = {
        t: "654c04eb527d4031196b7561",
        id: matchingOption,
        c: 1,
        lineItemType: "StoreListingV2"
      };

      // Insert the new reward at the specific index
      this.endlessOfferTrackRecord.EOrewards[index] = [newReward];

      // Explicitly wait for the state to be updated
      await this.updateRewardsData();

      await this.endlessOfferService.buildDisplayData(this.endlessOfferTrackRecord, index);

      // Update the rewards credits
      this.extractRewardsCreditsQA();
    }
  }


  private extractRewardsCreditsQA() {
    if (this.endlessOfferTrackRecord && this.endlessOfferTrackRecord.EOrewards) {
      this.endlessOfferTrackRecord.EOrewards.forEach((reward: any, index: number) => {
        if (reward && reward[0] && reward[0].id && reward[0].id.credits_ref?.qa) {
          this.rewards_credits[index] = reward[0].id.credits_ref.qa;
        } else {
          // Initialize empty array for rewards without credits
          this.rewards_credits[index] = [];

          // Warn user if this is a non-template (missing credits shouldn't happen)
          if (!this.isTemplate) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Missing Credits',
              detail: `Step ${index + 1} is missing store listing credits. Please verify the store listing selection.`,
              life: 5000
            });
          }
        }
      });
    }
  }


  async updateRewardsData() {
    // Use a promise to wait for the next event loop tick, ensuring state is updated
    await new Promise(resolve => setTimeout(resolve, 0));
    this.isLoading = false;
  }

  clearSelectedPaidOption(index: number) {
    if (this.endlessOfferTrackRecord && this.endlessOfferTrackRecord.EObundles && this.endlessOfferTrackRecord.EObundles[index]) {
      // this.endlessOfferTrackRecord.EObundles[index].listing = null;
    }
  }

  getCreditId(key: string): string {
    if (key) {
      return key.split('_')[1];
    } else {
      return 'undefined'
    }
  }

  getCreditCount(credit: any): any {
    return Object.values(credit)[0];
  }

  reOrderLists(event: any): void {
    if (!this.endlessOfferTrackRecord.EObundles || !this.endlessOfferTrackRecord.EOrewards) {
      return;
    }

    const movedBundle = event[0];
    if (movedBundle && typeof movedBundle.index === 'number') {
      const originalIndex = movedBundle.index;
      const newIndex = this.endlessOfferTrackRecord.EObundles.findIndex((bundle: any) => bundle.index === originalIndex);

      // Move the corresponding reward to match the new bundle position
      if (originalIndex !== newIndex && originalIndex < this.endlessOfferTrackRecord.EOrewards.length && newIndex < this.endlessOfferTrackRecord.EOrewards.length) {
        const [movedReward] = this.endlessOfferTrackRecord.EOrewards.splice(originalIndex, 1);
        this.endlessOfferTrackRecord.EOrewards.splice(newIndex, 0, movedReward);
      }
    }

    // Update index values in EObundles for future moves
    this.endlessOfferTrackRecord.EObundles.forEach((bundle: { index: any; }, index: any) => {
      bundle.index = index;
    });
  }

  removeBundle(index: number): void {
    // Remove the bundle at the specified index
    this.endlessOfferTrackRecord['EObundles']?.splice(index, 1);

    // Remove the corresponding reward at the same index
    this.endlessOfferTrackRecord['EOrewards']?.splice(index, 1);

    // Call onChange or any other function you need to update your component state
    this.onChange('EObundles', {});
    this.onChange('EOrewards', {});
  }

  setLoadingState(isLoading: boolean): void {
    this.isLoading = isLoading;
  }

  /**
   * Safely gets the store listing ID for a given reward index.
   * Returns undefined if the path doesn't exist, which is safe for ngModel binding.
   */
  getStoreListingId(index: number): string | undefined {
    const rewards = this.endlessOfferTrackRecord?.EOrewards;
    if (!rewards || !rewards[index] || !rewards[index][0]) {
      return undefined;
    }
    const reward = rewards[index][0];
    if (!reward.id) {
      return undefined;
    }
    return reward.id._id;
  }

  scrollToNewItem() {
    // Get the drop list by its ID and assert it's an HTMLElement
    const dropList = document.querySelector("#cdk-drop-list-0") as HTMLElement;

    // Check if the drop list exists and has children
    if (dropList) {
      // Set smooth scroll behavior
      dropList.style.scrollBehavior = 'smooth';

      // Use a setTimeout to give time for the scroll to finish before simulating the click
      setTimeout(() => {
        // Scroll the container to its maximum scroll height
        dropList.scrollTop = dropList.scrollHeight;
        // Access the last child of the drop list and assert it's an HTMLElement
        const lastListItem = dropList.lastElementChild as HTMLElement;

        if (lastListItem) {
          lastListItem.click();
        }
      }, 150); // Adjust the timeout duration as needed
    }
  }

}
